import { ItemListItem, ItemListRoot } from "./ItemList";

/** Zeilenliste des Kits mit `ItemList.Item`; eigene Datei wegen Fast Refresh. */
export const ItemList = Object.assign(ItemListRoot, { Item: ItemListItem });
